export default __webpack_public_path__ + "static/media/chemo-checklist.7ce05ee8.svg";